var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12"},[_c('PricingAnalytics',{staticClass:"h-auto",attrs:{"keyApi":"get_orders_sum_Money"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }